/*!

=========================================================
* Paper Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import ChartDetailScreen from "components/Screens/ChartDetailScreen";
import Dashboard from "views/Dashboard.js";
import Icons from "views/Icons.js";

var routes = [
  {
    path: "/dashboard",
    name: "Inicio",
    icon: "nc-icon nc-layout-11",
    //component: Dashboard,
    component: Dashboard,
    layout: "/admin",
    show: true
  },
  {
    path: "/viewChart/:id",
    name: "Ver gráfica",
    icon: "nc-icon nc-layout-11",
    //component: Dashboard,
    component: ChartDetailScreen,
    layout: "/admin",
    show: false
  },
  /* {
    path: "/lender",
    name: "Nóminas de cédulas",
    icon: "nc-icon nc-single-02",
    component: LenderList,
    layout: "/admin",
    show: true
  }, */
  /*   {
      path: "/icons",
      name: "Icons",
      icon: "nc-icon nc-diamond",
      component: Icons,
      layout: "/admin",
      show: true
    }, */
  /* 
  {
    path: "/maps",
    name: "Maps",
    icon: "nc-icon nc-pin-3",
    component: Maps,
    layout: "/admin",
    show: true
  },
  {
    path: "/notifications",
    name: "Notifications",
    icon: "nc-icon nc-bell-55",
    component: Notifications,
    layout: "/admin",
    show: true
  },
  {
    path: "/user-page",
    name: "User Profile",
    icon: "nc-icon nc-single-02",
    component: UserPage,
    layout: "/admin",
    show: true
  },
  {
    path: "/tables",
    name: "Table List",
    icon: "nc-icon nc-tile-56",
    component: TableList,
    layout: "/admin",
  },
  {
    path: "/typography",
    name: "Typography",
    icon: "nc-icon nc-caps-small",
    component: Typography,
    layout: "/admin",
    show: true
  },
  {
    pro: true,
    path: "/upgrade",
    name: "Upgrade to PRO",
    icon: "nc-icon nc-spaceship",
    component: UpgradeToPro,
    layout: "/admin",
    show: true
  }, */


];
export default routes;
